(function ($) {
	class W4D_ContactForm {
		constructor() {
			this.initSelectors();
			this.bindEvents();
		}

		initSelectors() {
			this.$form = $('#contactForm');
			this.$submitBtn = this.$form.find('button[type="submit"]');
		}

		bindEvents() {
			W4D_FrontendHelper.startButtonCountdownUntilEnabled(this.$submitBtn, 9);

			this.$form.validate({
				submitHandler: (form) => {
					if (!W4D_FrontendHelper.checkHoneypot(this.$form)) {
						return;
					}

					this.handleSubmit(form);
				},
			});
		}

		handleSubmit(form) {
			const fd = new FormData(form);

			fd.append('action', 'w4d_handle_contact_form_submit');
			fd.append('nonce', w4d_frontend_ajax.nonce);
			fd.append('product_id', W4D_FrontendHelper.getQueryParameter('id'));

			$.ajax({
				url: w4d_frontend_ajax.ajax_url,
				data: fd,
				method: 'POST',
				processData: false,
				contentType: false,
				beforeSend: () => {},
				success: (response) => {
					if (response.success) {
						this.$form.empty().html(response.data.success_html);
						W4D_Toast.showToast('success', response.data.message);
						this.$form[0].reset();
					} else {
						const errorMessage = response && response.data ? response.data.message : 'An unexpected error occurred';
						W4D_Toast.showToast('error', errorMessage);
					}
				},
				error: () => {
					W4D_Toast.showToast('error', 'Došlo je do pogreške. Pokušajte ponovno.');
				},
			});
		}
	}

	$(document).ready(function () {
		new W4D_ContactForm();
	});
})(jQuery);
